var map = {
	"./android.svg": 316,
	"./aws.svg": 634,
	"./azure.svg": 48,
	"./figma.svg": 625,
	"./firebase.svg": 332,
	"./flutter.svg": 59,
	"./html.svg": 584,
	"./javascript.svg": 566,
	"./leetcode.svg": 406,
	"./linux.svg": 215,
	"./microsoft.svg": 109,
	"./mongodb.svg": 795,
	"./mysql.svg": 455,
	"./nextjs.svg": 253,
	"./nodejs.svg": 766,
	"./postgresql.svg": 449,
	"./postman.svg": 243,
	"./powerbi.svg": 957,
	"./python.svg": 757,
	"./react.svg": 204,
	"./sap.svg": 993,
	"./swift.svg": 800,
	"./swiftIcon.svg": 99,
	"./tableau.svg": 63,
	"./tableauIcon.svg": 179,
	"./typescript.svg": 262,
	"shared/assets/logos/android.svg": 316,
	"shared/assets/logos/aws.svg": 634,
	"shared/assets/logos/azure.svg": 48,
	"shared/assets/logos/figma.svg": 625,
	"shared/assets/logos/firebase.svg": 332,
	"shared/assets/logos/flutter.svg": 59,
	"shared/assets/logos/html.svg": 584,
	"shared/assets/logos/javascript.svg": 566,
	"shared/assets/logos/leetcode.svg": 406,
	"shared/assets/logos/linux.svg": 215,
	"shared/assets/logos/microsoft.svg": 109,
	"shared/assets/logos/mongodb.svg": 795,
	"shared/assets/logos/mysql.svg": 455,
	"shared/assets/logos/nextjs.svg": 253,
	"shared/assets/logos/nodejs.svg": 766,
	"shared/assets/logos/postgresql.svg": 449,
	"shared/assets/logos/postman.svg": 243,
	"shared/assets/logos/powerbi.svg": 957,
	"shared/assets/logos/python.svg": 757,
	"shared/assets/logos/react.svg": 204,
	"shared/assets/logos/sap.svg": 993,
	"shared/assets/logos/swift.svg": 800,
	"shared/assets/logos/swiftIcon.svg": 99,
	"shared/assets/logos/tableau.svg": 63,
	"shared/assets/logos/tableauIcon.svg": 179,
	"shared/assets/logos/typescript.svg": 262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;